import * as React from 'react';
import * as propTypes from 'prop-types';
import { setRef } from '@sheerid/jslib';

interface PostalCodeInputProps {
    onChange: Function;
    value: any;
    isValid? : boolean;
    placeholder?: string;
}

const PostalCodeInput = ({
    onChange,
    value,
    isValid,
    placeholder,
}: PostalCodeInputProps) => {

    return (
        <input
            className={`sid-text-input sid-text-input--required
                sid-l-full-width ${isValid ? '' : 'sid-text-input--error'}`}
            id="sid-postal-code"
            name="sid-postal-code"
            pattern="\d*"
            type="text"
            value={value}
            placeholder={placeholder}
            onChange={e => onChange(e.target.value)}
            ref={input => setRef('postalCode', input)}
        />
    );
};

PostalCodeInput.propTypes = {
    isValid: propTypes.bool,
    placeholder: propTypes.string,
    onChange: propTypes.func.isRequired,
    value: propTypes.string,
};
PostalCodeInput.defaultProps = {
    isValid: true,
    placeholder: '',
    value: '',
};

export const PostalCodeInputComponent = PostalCodeInput;
